<template>
  <div>
    <canvas id="line-chart-categories"></canvas>
  </div>
</template>

<script>
  import moment from "moment";
import Chart from 'chart.js';
import { mapActions } from "vuex";

export default {
  name: 'LineChartCategories',
  props: ['id'],
  data() {
    return {
      chartLineData: {
        type: 'line',
        data: {
          labels: [],
          datasets: []
        }
      },
      month: null,
      cssKeywords: [{
        name: "aliceblue", value: 'rgba(240,248,255, 0.2)'},{
        name: "antiquewhite", value: 'rgba(250,235,215, 0.2)'},{
        name: "aqua", value: 'rgba(0,255,255, 0.2)'},{
        name: "aquamarine", value: 'rgba(127,255,212, 0.2)'},{
        name: "azure", value: 'rgba(240,255,255, 0.2)'},{
        name: "beige", value: 'rgba(245,245,220, 0.2)'},{
        name: "bisque", value: 'rgba(255,228,196, 0.2)'},{
        name: "black", value: 'rgba(0,0,0, 0.2)'},{
        name: "blanchedalmond", value: 'rgba(255,235,205, 0.2)'},{
        name: "blue", value: 'rgba(0,0,255, 0.2)'},{
        name: "blueviolet", value: 'rgba(138,43,226, 0.2)'},{
        name: "brown", value: 'rgba(165,42,42, 0.2)'},{
        name: "burlywood", value: 'rgba(222,184,135, 0.2)'},{
        name: "cadetblue", value: 'rgba(95,158,160, 0.2)'},{
        name: "chartreuse", value: 'rgba(127,255,0, 0.2)'},{
        name: "chocolate", value: 'rgba(210,105,30, 0.2)'},{
        name: "coral", value: 'rgba(255,127,80, 0.2)'},{
        name: "cornflowerblue", value: 'rgba(100,149,237, 0.2)'},{
        name: "cornsilk", value: 'rgba(255,248,220, 0.2)'},{
        name: "crimson", value: 'rgba(220,20,60, 0.2)'},{
        name: "cyan", value: 'rgba(0,255,255, 0.2)'},{
        name: "darkblue", value: 'rgba(0,0,139, 0.2)'},{
        name: "darkcyan", value: 'rgba(0,139,139, 0.2)'},{
        name: "darkgoldenrod", value: 'rgba(184,134,11, 0.2)'},{
        name: "darkgray", value: 'rgba(169,169,169, 0.2)'},{
        name: "darkgreen", value: 'rgba(0,100,0, 0.2)'},{
        name: "darkgrey", value: 'rgba(169,169,169, 0.2)'},{
        name: "darkkhaki", value: 'rgba(189,183,107, 0.2)'},{
        name: "darkmagenta", value: 'rgba(139,0,139, 0.2)'},{
        name: "darkolivegreen", value: 'rgba(85,107,47, 0.2)'},{
        name: "darkorange", value: 'rgba(255,140,0, 0.2)'},{
        name: "darkorchid", value: 'rgba(153,50,204, 0.2)'},{
        name: "darkred", value: 'rgba(139,0,0, 0.2)'},{
        name: "darksalmon", value: 'rgba(233,150,122, 0.2)'},{
        name: "darkseagreen", value: 'rgba(143,188,143, 0.2)'},{
        name: "darkslateblue", value: 'rgba(72,61,139, 0.2)'},{
        name: "darkslategray", value: 'rgba(47,79,79, 0.2)'},{
        name: "darkslategrey", value: 'rgba(47,79,79, 0.2)'},{
        name: "darkturquoise", value: 'rgba(0,206,209, 0.2)'},{
        name: "darkviolet", value: 'rgba(148,0,211, 0.2)'},{
        name: "deeppink", value: 'rgba(255,20,147, 0.2)'},{
        name: "deepskyblue", value: 'rgba(0,191,255, 0.2)'},{
        name: "dimgray", value: 'rgba(105,105,105, 0.2)'},{
        name: "dimgrey", value: 'rgba(105,105,105, 0.2)'},{
        name: "dodgerblue", value: 'rgba(30,144,255, 0.2)'},{
        name: "firebrick", value: 'rgba(178,34,34, 0.2)'},{
        name: "floralwhite", value: 'rgba(255,250,240, 0.2)'},{
        name: "forestgreen", value: 'rgba(34,139,34, 0.2)'},{
        name: "fuchsia", value: 'rgba(255,0,255, 0.2)'},{
        name: "gainsboro", value: 'rgba(220,220,220, 0.2)'},{
        name: "ghostwhite", value: 'rgba(248,248,255, 0.2)'},{
        name: "gold", value: 'rgba(255,215,0, 0.2)'},{
        name: "goldenrod", value: 'rgba(218,165,32, 0.2)'},{
        name: "gray", value: 'rgba(128,128,128, 0.2)'},{
        name: "green", value: 'rgba(0,128,0, 0.2)'},{
        name: "greenyellow", value: 'rgba(173,255,47, 0.2)'},{
        name: "grey", value: 'rgba(128,128,128, 0.2)'},{
        name: "honeydew", value: 'rgba(240,255,240, 0.2)'},{
        name: "hotpink", value: 'rgba(255,105,180, 0.2)'},{
        name: "indianred", value: 'rgba(205,92,92, 0.2)'},{
        name: "indigo", value: 'rgba(75,0,130, 0.2)'},{
        name: "ivory", value: 'rgba(255,255,240, 0.2)'},{
        name: "khaki", value: 'rgba(240,230,140, 0.2)'},{
        name: "lavender", value: 'rgba(230,230,250, 0.2)'},{
        name: "lavenderblush", value: 'rgba(255,240,245, 0.2)'},{
        name: "lawngreen", value: 'rgba(124,252,0, 0.2)'},{
        name: "lemonchiffon", value: 'rgba(255,250,205, 0.2)'},{
        name: "lightblue", value: 'rgba(173,216,230, 0.2)'},{
        name: "lightcoral", value: 'rgba(240,128,128, 0.2)'},{
        name: "lightcyan", value: 'rgba(224,255,255, 0.2)'},{
        name: "lightgoldenrodyellow", value: 'rgba(250,250,210, 0.2)'},{
        name: "lightgray", value: 'rgba(211,211,211, 0.2)'},{
        name: "lightgreen", value: 'rgba(144,238,144, 0.2)'},{
        name: "lightgrey", value: 'rgba(211,211,211, 0.2)'},{
        name: "lightpink", value: 'rgba(255,182,193, 0.2)'},{
        name: "lightsalmon", value: 'rgba(255,160,122, 0.2)'},{
        name: "lightseagreen", value: 'rgba(32,178,170, 0.2)'},{
        name: "lightskyblue", value: 'rgba(135,206,250, 0.2)'},{
        name: "lightslategray", value: 'rgba(119,136,153, 0.2)'},{
        name: "lightslategrey", value: 'rgba(119,136,153, 0.2)'},{
        name: "lightsteelblue", value: 'rgba(176,196,222, 0.2)'},{
        name: "lightyellow", value: 'rgba(255,255,224, 0.2)'},{
        name: "lime", value: 'rgba(0,255,0, 0.2)'},{
        name: "limegreen", value: 'rgba(50,205,50, 0.2)'},{
        name: "linen", value: 'rgba(250,240,230, 0.2)'},{
        name: "magenta", value: 'rgba(255,0,255, 0.2)'},{
        name: "maroon", value: 'rgba(128,0,0, 0.2)'},{
        name: "mediumaquamarine", value: 'rgba(102,205,170, 0.2)'},{
        name: "mediumblue", value: 'rgba(0,0,205, 0.2)'},{
        name: "mediumorchid", value: 'rgba(186,85,211, 0.2)'},{
        name: "mediumpurple", value: 'rgba(147,112,219, 0.2)'},{
        name: "mediumseagreen", value: 'rgba(60,179,113, 0.2)'},{
        name: "mediumslateblue", value: 'rgba(123,104,238, 0.2)'},{
        name: "mediumspringgreen", value: 'rgba(0,250,154, 0.2)'},{
        name: "mediumturquoise", value: 'rgba(72,209,204, 0.2)'},{
        name: "mediumvioletred", value: 'rgba(199,21,133, 0.2)'},{
        name: "midnightblue", value: 'rgba(25,25,112, 0.2)'},{
        name: "mintcream", value: 'rgba(245,255,250, 0.2)'},{
        name: "mistyrose", value: 'rgba(255,228,225, 0.2)'},{
        name: "moccasin", value: 'rgba(255,228,181, 0.2)'},{
        name: "navajowhite", value: 'rgba(255,222,173, 0.2)'},{
        name: "navy", value: 'rgba(0,0,128, 0.2)'},{
        name: "oldlace", value: 'rgba(253,245,230, 0.2)'},{
        name: "olive", value: 'rgba(128,128,0, 0.2)'},{
        name: "olivedrab", value: 'rgba(107,142,35, 0.2)'},{
        name: "orange", value: 'rgba(255,165,0, 0.2)'},{
        name: "orangered", value: 'rgba(255,69,0, 0.2)'},{
        name: "orchid", value: 'rgba(218,112,214, 0.2)'},{
        name: "palegoldenrod", value: 'rgba(238,232,170, 0.2)'},{
        name: "palegreen", value: 'rgba(152,251,152, 0.2)'},{
        name: "paleturquoise", value: 'rgba(175,238,238, 0.2)'},{
        name: "palevioletred", value: 'rgba(219,112,147, 0.2)'},{
        name: "papayawhip", value: 'rgba(255,239,213, 0.2)'},{
        name: "peachpuff", value: 'rgba(255,218,185, 0.2)'},{
        name: "peru", value: 'rgba(205,133,63, 0.2)'},{
        name: "pink", value: 'rgba(255,192,203, 0.2)'},{
        name: "plum", value: 'rgba(221,160,221, 0.2)'},{
        name: "powderblue", value: 'rgba(176,224,230, 0.2)'},{
        name: "purple", value: 'rgba(128,0,128, 0.2)'},{
        name: "rebeccapurple", value: 'rgba(102, 51, 153, 0.2)'},{
        name: "red", value: 'rgba(255,0,0, 0.2)'},{
        name: "rosybrown", value: 'rgba(188,143,143, 0.2)'},{
        name: "royalblue", value: 'rgba(65,105,225, 0.2)'},{
        name: "saddlebrown", value: 'rgba(139,69,19, 0.2)'},{
        name: "salmon", value: 'rgba(250,128,114, 0.2)'},{
        name: "sandybrown", value: 'rgba(244,164,96, 0.2)'},{
        name: "seagreen", value: 'rgba(46,139,87, 0.2)'},{
        name: "seashell", value: 'rgba(255,245,238, 0.2)'},{
        name: "sienna", value: 'rgba(160,82,45, 0.2)'},{
        name: "silver", value: 'rgba(192,192,192, 0.2)'},{
        name: "skyblue", value: 'rgba(135,206,235, 0.2)'},{
        name: "slateblue", value: 'rgba(106,90,205, 0.2)'},{
        name: "slategray", value: 'rgba(112,128,144, 0.2)'},{
        name: "slategrey", value: 'rgba(112,128,144, 0.2)'},{
        name: "snow", value: 'rgba(255,250,250, 0.2)'},{
        name: "springgreen", value: 'rgba(0,255,127, 0.2)'},{
        name: "steelblue", value: 'rgba(70,130,180, 0.2)'},{
        name: "tan", value: 'rgba(210,180,140, 0.2)'},{
        name: "teal", value: 'rgba(0,128,128, 0.2)'},{
        name: "thistle", value: 'rgba(216,191,216, 0.2)'},{
        name: "tomato", value: 'rgba(255,99,71, 0.2)'},{
        name: "turquoise", value: 'rgba(64,224,208, 0.2)'},{
        name: "violet", value: 'rgba(238,130,238, 0.2)'},{
        name: "wheat", value: 'rgba(245,222,179, 0.2)'},{
        name: "white", value: 'rgba(255,255,255, 0.2)'},{
        name: "whitesmoke", value: 'rgba(245,245,245, 0.2)'},{
        name: "yellow", value: 'rgba(255,255,0, 0.2)'},{
        name: "yellowgreen", value: 'rgba(154,205,50, 0.2)'
      }]
    }
  },
  methods: {
     moment,
    ...mapActions("session", ["userHistorySessions"]),
    getHistorical(monthprop) {
      const vm = this;
      const year = vm.year ? vm.year : 2023;
      const month = monthprop ? monthprop : null;
      const id = this.id;
      const data = {
        id,
        year, 
        month
      };
      let labels = [];
      let objectArr = [];
      const loading = vm.$toast.loading("Cargando semanas...");
      vm.userHistorySessions(data).then(response => {
        vm.sessions = response.message;
        let objectCat = {};
        let indexCssKey = 0;
        for (let s of vm.sessions) {
          labels.push(s.name);
          for (let r of s.results) {
            objectCat = {label: '', data: [], backgroundColor: [], borderColor: [], pointBorderColor: [], fill: false};
            let exists = false;
            let existindex = null;
            let colorCode = null;

            if (objectArr.length == 0) {
              console.log("ONE ELEMENT");
              colorCode = this.getBackGroundColor(indexCssKey);
              objectCat.label = r.category_name;
              objectCat.data.push(r.total_value);
              objectCat.backgroundColor.push(colorCode);
              objectCat.borderColor.push(colorCode);
              objectCat.pointBorderColor.push(colorCode);
              objectArr.push(objectCat);
            } else {
              console.log("NEW ELEMENT");
              for (let index in objectArr) {
                if (objectArr[index].label == r.category_name) {
                  exists = true
                  existindex = index;
                }
              }

              if (exists) {
                colorCode = this.getBackGroundColor(indexCssKey);
                objectArr[existindex].data.push(r.total_value);
                objectArr[existindex].backgroundColor.push(colorCode);
                objectArr[existindex].borderColor.push(colorCode);
                objectArr[existindex].pointBorderColor.push(colorCode);
              } else {
                colorCode = this.getBackGroundColor(indexCssKey);
                objectCat.label = r.category_name;
                objectCat.data.push(r.total_value);
                objectCat.backgroundColor.push(colorCode);
                objectCat.borderColor.push(colorCode);
                objectCat.pointBorderColor.push(colorCode);
                objectArr.push(objectCat);
              }

            }

            indexCssKey++;
          }
        }
        console.log(objectArr);
        vm.chartLineData.data.labels = labels;
        vm.chartLineData.data.datasets = objectArr;
        const ctx = document.getElementById('line-chart-categories');
        new Chart(ctx, this.chartLineData);
      });
      vm.loaded = true;
      loading.hide();
    },
    getYears() {
      const vm = this;
      let currentYear = new Date().getFullYear();
      if(!vm.year) {
        vm.year = currentYear;
      }
    },
    getMonths() {
      const vm = this;
      
      let startMonth = 1;
      let endMonth = new Date().getFullYear() == vm.year ? new Date().getMonth() + 1 : 12;
      if(!vm.month) {
        vm.month = endMonth;
      }
    },
    updateChart(month) {
      console.log("intentando actualizar");
      this.getHistorical(month);
    },
    getBackGroundColor(index) {
      return this.cssKeywords[index].value;
    }
  },
  mounted() {
    this.getYears();
    this.getMonths();
    this.getHistorical();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/lineChartCategories.vue